const LabelHelper = {
	paymentStatus(status){
		switch (status) {
			case 'paid':
				return 'Paid';
			case 'pending':
				return 'Pending';
			case 'confirmed':
				return 'Confirmed';
			case 'refunded':
				return 'Refunded';
			case 'cancelled':
				return 'Cancelled';
			default:
				break;
		}
	},
	paymentMethod(method) {
		switch (method) {
			case 'new_visa_master':
				return 'Visa / Master';
			case 'new_union_pay':
				return 'Union Pay';
			case 'alipay':
				return 'Alipay (Web)';
			case 'alipay_hk_app':
				return 'AlipayHK (InApp)';
			case 'alipay_cn_app':
				return '支付宝 (InApp)';
			case 'wechat_pay':
				return 'WeChat Pay';
			case 'fps':
				return 'FPS';
			case 'union_pay':
				return 'Union Pay';
			case 'visa_master':
				return 'Visa / Master';
			default:
		}
		return '';
	},
	machineStatus(status) {
		switch (status) {
			case 'available':
			case 'enabled':
				return 'Available';
			case 'disabled':
				return 'Unavailable';
			case 'reserved':
				return 'On hold';
			case 'in_use':
				return 'In Use';
			case 'maintenance':
				return 'Maintenance';
			default:
		}

		return '';
	}
};

export default LabelHelper;
